<template>
  <div class="one-column-view">
    <div class="article-content">
        <div class="row">
            <div class="col-12">
                <h1 class="mb-4">隐私政策</h1>
                <p class="fw-bold mb-0">最近更新：2021 年 10 月 3 日</p>
                <p class="fw-bold mb-0">访问网站的协议</p>
                <p>GoldenLink Plus（“GOLD”）是一个商业社交媒体平台，用于连接用于各种营销目的的企业和营销人员，企业和营销人员都提供商业和人口统计数据，以促进整个平台的所有商业活动。GOLD 致力于保护隐私并使用标准的数据控制业务流程来保护其成员和用户。</p>

                <p>本隐私政策解释了 GOLD 以及 GOLD 拥有或注册的所有相关网站的数据收集和使用做法。它不适用于 GOLD 不负责的任何第三方网站、应用程序、产品或服务。</p>
                <p>一旦您完成我们的注册程序，即表示您同意本政策以及条件条款以及网站的商业协议和 Gold Striker 协议中描述的信息收集和使用做法。如果您不同意本隐私政策的条款、使用条款和本网站提供的其他条款，请不要向 Gold 提供任何信息或使用任何提及的网站上提供或提供的任何服务或产品在本隐私政策中。</p>

                <p class="color-gold fw-bold mb-0">隐私政策更新</p>
                <p>本隐私政策会不时更改，更改在发布后生效。定期查看本政策以获取更新是您的唯一责任，并且您全权负责了解本网站和本网站上所有发布的政策的任何更改。GOLD 不会以任何方式通知任何更改，除非在本网站上发布更改。</p>

                <p class="color-gold fw-bold mb-0">信息的收集和使用</p>
                <p>本政策适用于 GOLD 在其 (a) 网站，包括其所有部门、子公司和相关公司（统称“网站”），(b) 在各种第三方网站上收集、使用、存储和披露信息(c) GOLD 的其他信息收集，包括从第三方购买客户名单，或使用来自第三方的客户名单。GOLD 不对第三方网站或应用程序的信息收集或隐私惯例负责。GOLD 不对任何 GS 或企业在开展营销活动期间使用的任何其他第三方网站或应用程序负责，任何和所有此类使用将由该 GS 或企业自行负责。</p>

                <p class="color-gold fw-bold mb-0">1. 信息收集</p>

                <p class="color-gold fw-bold mb-0">1.1。用户直接信息：</p>
                <p>作为一个社交媒体平台，我们的各个成员可能会收集信息，作为其业务和活动要求的一部分。在任何企业或 GS 营销人员收集个人信息的情况下，我们不会指示他们或要求他们这样做，但他们可能会作为其业务实践的一部分，在这种情况下，企业或 GS 负有全部责任，以确保适当的此类收集的信息的保护和隐私。</p>

                <p class="color-gold fw-bold mb-0">1.2. 调查活动：</p>
                <p>GS 或 Business 可能会在您自愿完成调查、订单或注册页面时从您那里收集信息，无论是通过使用互联网在线、离线通过邮件、亲自或使用电话提供此信息，或在任何实时音频期间事件，这些活动都与 GS 或 Business 使用的各种营销活动有关。这些信息也可能通过第三方运营的调查、订单或注册页面收集。这种收集方法统称为“调查”。在此类调查中，GS 或 Business 可能会要求您提供个人身份信息，包括您的姓名、电子邮件地址、街道地址、邮政编码、电话号码（包括手机号码和运营商）、出生日期、性别、工资范围、教育和婚姻状况，职业、就业信息、个人和在线兴趣，以及可能不时要求的其他信息。Business 和 GS 均承认并接受，作为其社交媒体活动的一部分，他们必须遵守有关收集和保护个人身份数据的所有联邦和州法律。</p>

                <p class="color-gold fw-bold mb-0">1.3 其他收集个人信息的方法：</p>
                <p>GS 或企业从您那里获取信息的其他情况包括 (1) 您领取奖品或寻求兑换企业和 GS 提供的奖励，(2) 您通过 GOLD 的客户服务部门请求帮助。</p>

                <p class="color-gold fw-bold mb-0">1.4 使用技术收集的 Cookie、跟踪像素和其他信息：</p>
                <p>GS、Business 或 GOLD 目前使用 cookie 和跟踪像素技术将某些与您有关的互联网相关信息与其数据库中有关您的信息相关联。此外，GS、Business 或 GOLD 将来可能会使用其他新的和不断发展的信息来源。(a) Cookies：“Cookies”是您浏览器软件的一项功能。如果启用，我们可能会编写 cookie，这些 cookie 可能会在您的计算机上存储有关您访问本网站任何页面的少量数据。Cookie 帮助我们跟踪我们的哪些功能对您最有吸引力，以及您在过去访问中可能查看过哪些内容。当您再次访问本网站时，cookies 可以让我们根据您的喜好定制我们的内容。我们可能会使用 cookie 来： 跟踪对本网站的回访次数；累积和报告汇总，有关网站使用情况的统计信息；根据您的兴趣或过去的观看历史向您提供特定内容；保存您的密码以便于访问我们的网站。您可以禁用 cookie，尽管本网站可能无法为您正常运行。您可以修改您的浏览器首选项以接受或拒绝所有 cookie，或在设置 cookie 时请求通知。您可以在 http://cookiecentral.com 阅读更多关于 cookie 的信息。为了使用 GS、Business 或 GOLD 网站的所有功能和功能，您需要接受 cookie。(b) 跟踪像素：跟踪像素是一种编程代码，可用于在网页上显示图像，但也可用于将您的唯一用户标识传输到数据库并将您与先前获取的有关个人的信息相关联在数据库中。这允许 GS、业务、或 GOLD 来跟踪您访问的某些网站。跟踪像素用于跟踪在线行为习惯以用于营销目的，以确定您可能感兴趣的产品或服务。除了在网页上使用跟踪像素外，GS、Business 或 GOLD 还在发送给所列个人的电子邮件中使用跟踪像素在 GS、Business 或 GOLD 的数据库中。(c) IP 地址：GS、Business 或 GOLD 会根据您在网站上的行为自动跟踪某些信息。我们可能会使用这些信息对用户的人口统计、兴趣和行为进行内部研究，以更好地了解、保护和服务您和我们的社区。这些信息可能包括您刚刚访问的网站、您继续访问的下一个网站、您的计算机浏览器信息和您的 IP 地址。您的 Internet 协议 (" 或 GOLD 还可能收集和积累其他匿名数据，以帮助我们了解和分析访问者的互联网体验。例如，GS、Business 或 GOLD 可能会积累与引用域名、使用的浏览器类型、操作系统软件、屏幕分辨率、颜色功能、浏览器插件、语言设置、cookie 偏好、搜索引擎关键字和JavaScript 启用。当您向我们提供个人身份信息时，我们能够使用此类访问者数据来识别您的身份。(e) 数据挖掘：如果 GS、Business 或 GOLD 的客户使用数据挖掘技术，可能会不时采用。(f) 新技术：互联网上技术的使用，包括 cookie 和跟踪像素，正在迅速发展。因此，GS、Business、</p>

                <p class="color-gold fw-bold mb-0">1.5 没有从儿童那里收集信息：</p>
                <p>GS、Business 或 GOLD 绝不会故意收集有关 18 岁以下儿童的任何个人信息。如果 GS、Business 或 GOLD 实际知道它已收集有关 18 岁以下儿童的个人信息，则该信息将被立即从其数据库中删除。由于不收集此类信息，GS、Business 或 GOLD 没有此类信息可供使用或向第三方披露。GOLD 设计此政策是为了遵守《儿童在线隐私保护法》（“COPPA”）。</p>

                <p class="color-gold fw-bold mb-0">1.6 信用卡信息：</p>
                <p>注意：以下内容适用于所有用户：GOLD 目前不收集任何信用卡信息，任何 GS 或企业也不应随时尝试从您那里收集信用卡信息。这是当前的 GOLD 政策。</p>

                <p class="color-gold fw-bold mb-0">2. 个人信息的使用</p>
                <p>以下部分描述了 GS 和 Business 如何使用个人信息。这些部分中描述的用途可能随时更改。由于 GOLD 是一个社交媒体营销平台，Business 和 GS 可能会通过电子邮件广告、电话营销、直邮营销、横幅、弹出窗口、短信、活动建议、推送通知等，无论采用何种方式，Business 和 GS 将始终遵守所有必要的法律、规则和法规。</p>

                <p class="color-gold fw-bold mb-0">2.1 电子邮件：</p>
                <p>作为使用 GOLDs 社交媒体平台的一部分，您承认并同意，GOLD 可能会不时发送有关注册或营销优惠设置或会员验证或认证或您在平台上的成就的确认电子邮件，包括其他重要公告.</p>
                <p>任何与营销相关的电子邮件都来自企业或 GS，这些电子邮件必须遵守所有法律和法规，并且还必须包含根据要求取消订阅的功能。如果您想结束任何电子邮件，您只需按该消息上的取消订阅按钮。</p>
                <p>请选择任何 GOLD 电子邮件底部的“取消订阅”选项来取消订阅，您了解您不会收到任何与您的帐户相关的社交媒体事件和活动，包括可能对您有很大好处的事件。</p>

                <p class="color-gold fw-bold mb-0">2.2 分析和目标广告：</p>
                <p>GOLD 可能会使用您的信息来制作和改进您的个人资料，跟踪您的在线浏览习惯并确定 GOLD 网站的哪些区域最常被访问。此信息有助于 GOLD 更好地了解您的兴趣，以便向您定位广告和促销活动。GOLD 可以自行决定通过使用电子邮件、直邮、电话、手机和其他通信方式来提供促销优惠的目标广告。所有营销活动（包括现场音频活动）和调查都必须遵守所有联邦和州隐私法。</p>

                <p class="color-gold fw-bold mb-0">2.3 个人信息的存储：</p>
                <p>GOLD 将您的信息存储在 GOLD 服务器上的数据库中。我们的服务器设有安全措施（例如防火墙），以防止 GOLD 控制下的信息丢失、滥用和更改。尽管有这些措施，GOLD 不能保证其安全措施将防止 GOLD 计算机被非法访问，以及您的信息不会被盗或更改。</p>

                <p class="color-gold fw-bold mb-0">3. 个人信息的使用</p>

                <p class="color-gold fw-bold mb-0">3.1 出售或转让给第三方：</p>
                <p>Gold 不会在任何时候以任何理由将您的信息出售或出租给任何其他方在使用期间。</p>
                <p>接受我们的条款和条件后，您承认并同意，无论 GoldenLink 采取何种保护措施和政策，保护您的个人和私人信息的最终责任均由平台用户您承担。</p>
                <p>Gold 平台上的任何企业或营销商均同意遵守本隐私政策以及条款和条件中包含的所有规定的隐私政策。单击此处查看条款和条件。</p>
                <p>如果任何用户不遵守他们在本隐私政策中同意的隐私政策，则该用户将违反并受到 Gold 自行决定从平台中删除和其他法律行动</p>
                <p>任何时候任何企业或营销人员都不得在平台上出售或出租任何用户的私人个人信息。</p>

                <p class="color-gold fw-bold mb-0">3.2 客户服务</p>
                <p>GOLD 将使用您的个人信息来回复您，处理、验证和验证请求和/或采购订单，满足您的任何请求并定制您在我们网站上的体验。</p>

                <p class="color-gold fw-bold mb-0">3.3 营销：</p>
                <p>GOLD 只会代表 GOLD 及其附属公司和子公司将您的个人信息用于营销和调查目的。GOLD 仅在获得您的批准后才允许向第三方代理、独立承包商或任何其他实体披露您的个人信息，下文第 3.4 节除外。</p>

                <p class="color-gold fw-bold mb-0">3.4 遵守法律程序：</p>
                <p>GOLD 将使用或披露您的个人信息以响应传票、法院命令、搜查令或法律程序，或以其他方式确立或行使我们的合法权利或针对法律索赔进行辩护，或在您违反或违反与 GOLD 的协议的情况下使用或披露您的个人信息。如果我们认为您会损害 GOLD、其所有者或 GOLD 其他客户的财产或权利，GOLD 将使用和披露您的个人信息。最后，如果我们认为有必要共享信息以对非法活动、涉嫌欺诈、可能对任何人的人身安全构成威胁的情况、违反GOLD 的可接受使用政策，或在回应传票时法律另有要求。</p>

                <p class="color-gold fw-bold mb-0">3.5 订单完成度：</p>
                <p>GOLD 会在必要时将您的个人信息传输给第三方，以提供您在使用 GOLD 的网站或响应 GOLD 提供的报价时从第三方订购的产品或服务。</p>

                <p class="color-gold fw-bold mb-0">3.6 数据摘要：</p>
                <p>GOLD 可能会出售或转让非个人信息，例如关于所有人或子群体的汇总或汇总匿名信息。</p>

                <p class="color-gold fw-bold mb-0">3.7. 其他访问个人信息：</p>
                <p>您可以访问您在注册金牌服务时提交的个人信息。您可以登录以更新此类信息。</p>

                <p class="color-gold fw-bold mb-0">4. 第三方的隐私惯例</p>

                <p class="color-gold fw-bold mb-0">4.1 广告商 cookie 和跟踪像素：</p>
                <p>在网站和互联网上投放广告的广告代理商、广告网络和其他公司通常可能会使用自己的 cookie、跟踪像素和其他技术来收集有关个人的信息。GOLD 不控制此类技术的使用，并且 GOLD 对使用此类技术收集有关您的信息不承担任何责任。</p>

                <p class="color-gold fw-bold mb-0">4.2 链接：</p>
                <p>网站和电子邮件信息有时包含指向第三方网站的超文本链接。GOLD 不对此类其他网站的隐私惯例或内容负责。链接的网站可能包含指向第三方维护的网站的链接。提供这些链接是为了您的方便和参考。GOLD 不会在任何方面运营或控制此类第三方网站上提供的任何信息、软件、产品或服务。包含指向网站的链接并不意味着对服务或网站、其内容或其赞助组织的任何认可。</p>

                <p class="color-gold fw-bold mb-0">5.退订程序</p>
                <p class="mb-0">如果您希望停止接收来自 GOLD 的电子邮件，您可以：</p>
                <ol type="a">
                    <li>按“退订”按钮退订发送给您的电子邮件。</li>
                    <li>通过发送电子邮件至 support@goldenlinkplus.com 取消订阅。 </li>
                </ol>

            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped></style>
